import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import axios from 'axios'
import App from './App.jsx'
import { getSession } from './lib/session'
import './index.css'

// Attach the active tenant's API key to every request. The backend derives
// the tenant namespace from this Bearer token, so no page needs to know it.
axios.interceptors.request.use((cfg) => {
  const s = getSession()
  if (s?.apiKey) cfg.headers.Authorization = `Bearer ${s.apiKey}`
  return cfg
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2
    }
  }
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
